<template>
  <div class="warehouseFramework">
    <div class="select">
      <table>
        <tr>
          <td style="width: 50%;">选择仓库：
            <el-select v-model="warehouse" placeholder="选择仓库">
              <el-option
                v-for="item in warehouseOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </td>
          <td>
            <el-button style="background-color: #FF9000; color: #FFFFFF;">搜索</el-button>
            <el-button type="info">清空</el-button>
          </td>
        </tr>
      </table>
    </div>
    <div class="data" style="width: 100%; height: 80%">
      <el-button style="background-color: #FF9000; float: left; color: #FFFFFF; margin: 50px 10px 10px"
                 icon="el-icon-plus" @click="dialogVisible1 = true">新增仓库
      </el-button>
      <el-table
        :data="warehouseData"
        border
        style="width: 100%; height: 95%;">
        <el-table-column
          prop="warehouseName"
          label="仓库名称"
          align="center">
        </el-table-column>
        <el-table-column
          prop="region"
          label="所属地区"
          align="center">
        </el-table-column>
        <el-table-column
          prop="address"
          label="详细地址"
          align="center">
        </el-table-column>
        <el-table-column
          prop="person"
          label="仓库负责人"
          align="center">
        </el-table-column>
        <el-table-column
          prop="parent"
          label="上级仓库"
          align="center">
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          align="center">
        </el-table-column>
        <el-table-column
          prop="operationPerson"
          label="操作人"
          align="center">
        </el-table-column>
        <el-table-column
          prop="edit"
          label="编辑"
          align="center">
          <el-button type="text" @click="dialogVisible = true">编辑</el-button>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage4"
          :page-size="100"
          layout="total, prev, pager, next, jumper"
          :total="400">
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="编辑仓库"
      align="left"
      :visible.sync="dialogVisible"
      width="50%">
      <div class="dialog" style="width:100%; height: 250px;">
        <table style="width:100%; text-align: left">
          <tr>
            <td><span style="color: red">*</span><span>仓库名称：</span>
              <el-input v-model="editWarehouseName"></el-input>
            </td>
            <td><span>仓库负责人：</span>
              <el-select v-model="value" clearable placeholder="仓库负责人" style="width: 77%">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </td>
          </tr>
          <tr style="height: 70px">
            <td><span style="color: red">*</span><span>详细地址：</span>
              <el-input v-model="editWarehouseName"></el-input>
            </td>
            <td><span style="margin-right: 14px">上级仓库：</span>
              <el-select v-model="value" clearable placeholder="上级仓库" style="width: 77%">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </td>
          </tr>
          <tr>
            <td><span style="color: red">*</span><span>所属地区：</span>
              <el-select v-model="value" clearable placeholder="省">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <el-select v-model="value" clearable placeholder="市">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <el-select v-model="value" clearable placeholder="区">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </td>
          </tr>
        </table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="新增仓库"
      align="left"
      :visible.sync="dialogVisible1"
      width="50%">
      <div class="dialog" style="width:100%; height: 250px;">
        <table style="width:100%; text-align: left">
          <tr>
            <td><span style="color: red">*</span><span>仓库名称：</span>
              <el-input v-model="editWarehouseName"></el-input>
            </td>
            <td><span>仓库负责人：</span>
              <el-select v-model="value" clearable placeholder="仓库负责人" style="width: 77%">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </td>
          </tr>
          <tr style="height: 70px">
            <td><span style="color: red">*</span><span>详细地址：</span>
              <el-input v-model="editWarehouseName"></el-input>
            </td>
            <td><span style="margin-right: 14px">上级仓库：</span>
              <el-select v-model="value" clearable placeholder="上级仓库" style="width: 77%">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </td>
          </tr>
          <tr>
            <td><span style="color: red">*</span><span>所属地区：</span>
              <el-select v-model="value" clearable placeholder="省">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <el-select v-model="value" clearable placeholder="市">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <el-select v-model="value" clearable placeholder="区">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </td>
          </tr>
        </table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'WarehouseFramework',
  data() {
    return {
      warehouse: '',
      dialogVisible: false,
      dialogVisible1: false,
      warehouseOptions: [{
        value: '1',
        label: '总仓库'
      },
        {
          value: '2',
          label: '西安仓库'
        }],
      warehouseData: [{
        warehouseName: '总仓库'
      }]
    }
  }
}
</script>

<style scoped>
.warehouseFramework {
  width: 100%;
  height: 100%;
  background-color: #FFFFFF;
}

.select {
  width: 100%;
  height: 7%;
}

.select table {
  font-size: 16px;
  text-align: left;
  width: 50%;
  margin: auto;
}

.select table .el-input {
  width: 20%;
}

.dialog table tr td {
  width: 50%;
}

.dialog .el-input {
  width: 77%;
}

.dialog .el-select {
  width: 25%;
}
</style>



// WEBPACK FOOTER //
// src/pages/warehouse/warehousemanagement/warehouseframework.vue